<template>
  <div class="form-group mt-3">
    <label
      v-if="labelName"
      for="price"
      class="pj-ui-label"
      :class="{ 'fs-4': isSelfService }"
    >
      {{ labelName }}
    </label>
    <div class="d-flex">
      <div class="currency-sign p-2">
        {{ currency.sign }}
      </div>
      <div class="currency-input flex-fill p-2">
        <input
          id="price"
          type="number"
          v-model="formPrice"
          class="form-control pj-input"
          :class="{ 'fs-3 pj-ss-input': isSelfService }"
          aria-describedby="PricelHelp"
          :placeholder="placeholder"
          :disabled="disabled"
          @keyup="emitDelayed(1)"
          @change="emitValue(1)"
        />
      </div>
      <div class="currency-update-btn flex-fill" v-show="showUpdateButton">
        <ButtonContinue
          v-show="showUpdateButton"
          :isEnabled="readyToUpdate"
          :label="t('SHARED.CONTINUE')"
          @callback="emitValue(0)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import ButtonContinue from "@/apps/merchant3/shared-components/ui/ButtonContinue.vue";
import { ICurrencyType } from "@/apps/merchant3/shared-hooks/useCurrency";

export default defineComponent({
  name: "InputFieldPrice",
  components: {
    ButtonContinue,
  },
  props: {
    labelName: String,
    placeholder: String,
    inputValue: {
      type: String,
      default: "",
    },
    currency: {
      type: Object as PropType<ICurrencyType>,
      default: () => ({ name: "US Dollar", code: "USD", sign: "$" }),
    },
    disabled: {
      default: false,
    },
    visible: {
      default: true,
    },
    isSelfService: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["price-emit"],

  setup(props, { emit }) {
    const { t } = useI18n();
    const formPrice = ref(props.inputValue);
    const showUpdateButton = ref(props.visible);
    const readyToUpdate = ref(false);
    const intervalSeconds = ref(0);
    const requestSent = ref(false);

    if (props.disabled == true) {
      showUpdateButton.value = false;
    }

    watchEffect(() => {
      if (props.inputValue !== undefined) {
        formPrice.value = props.inputValue;
      }
    });
    const emitValue = (onChange = 0) => {
      if (intervalSeconds.value) {
        clearInterval(intervalSeconds.value);
      }
      if (requestSent.value) {
        return;
      }
      emit("price-emit", formPrice.value, onChange);
      if (props.visible) {
        if (onChange == 1) {
          showUpdateButton.value = true;
        } else {
          showUpdateButton.value = false;
        }
      }
      setTimeout(() => (requestSent.value = true), 500);
    };
    const emitDelayed = (onChange = 0) => {
      requestSent.value = false;
      if (intervalSeconds.value) {
        clearInterval(intervalSeconds.value);
      }
      let seconds = 0;
      intervalSeconds.value = setInterval(() => {
        seconds++;
        if (!requestSent.value && seconds >= 3) {
          emitValue(onChange);
        }
        if (seconds > 5) {
          clearInterval(intervalSeconds.value);
        }
      }, 1000);
    };
    const setInputPrice = (value: string) => {
      formPrice.value = value;
    };
    const componentReady = (value: boolean) => {
      readyToUpdate.value = value;
    };

    return {
      t,
      formPrice,
      emitValue,
      emitDelayed,
      showUpdateButton,
      readyToUpdate,
      componentReady,
      setInputPrice,
    };
  },
});
</script>
<style scoped>
.currency-sign {
  font-size: calc(1.325rem + 0.9vw);
}
</style>
